import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import DataGrid, { Column, Editing, Paging, Pager, RemoteOperations } from "devextreme-react/ui/data-grid";
import getForm from "./form";

import { doDeleteRol, doCreateRol, doUpdateRol, getRolFuncionalities } from "./actions";

import { setSelectedFuncionalities, setEventDataRol } from "../../General/actions";
import ModalDelete from "../modalDelete";

import TableFilter from "../../../../Shared/tableFilter.jsx";
import { Button } from "devextreme-react";

class RolesTable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.contador = 0;
    this.tableRef = React.createRef();
    this.state = {
      selectedPerfil: "",
      selectedRowId: null,
      modalDelete: false,
      deleteEvent: null,
      allowEditPerfil: false,
    };
  }


  onPageChanged = (data) => {
    const { currentPage, totalPages } = data;

    const indexPage = currentPage - 1;

    this.tableRef.pageIndex(indexPage);
    this.setState({ currentPage, totalPages });
  };


  // action ingresar
  handleAdd = () => {
    this.props.dispatch(setSelectedFuncionalities([]));
    this.setState({ selectedPerfil: "", allowEditPerfil: true });
    this.tableRef.addRow();
  }
  handleSave = (event) => {
    event.cancel = true;
    this.props.dispatch(doCreateRol(event));
    event.component.cancelEditData();
  }

  // action eliminar
  handleOpenModalDelete = (r) => {
    this.tableRef.deleteRow(r.row.rowIndex);
  }
  handleRemove = (event) => {
    if (this.state.deleteEvent === null) {
      this.setState({ modalDelete: true, deleteEvent: event });
      event.cancel = true;
    }
  }
  removeRol = () => {
    this.props.dispatch(doDeleteRol(this.state.deleteEvent.data.Id));
    this.setState({ modalDelete: false, deleteEvent: null });
  }
  handleCancelRemove = () => {
    this.setState({ modalDelete: false, deleteEvent: null });
  }
  // action Editar
  handleOpenModalEdit = (e) => {
    this.setState({ allowEditPerfil: false });
    this.tableRef.editRow(e.row.rowIndex);
  }
  handleEdit = (e) => {
    const event = {};
    event.cancel = e.cancel;
    event.data = e.data;
    this.props.dispatch(setSelectedFuncionalities(null));
    this.props.dispatch(setEventDataRol(event));
    this.props.dispatch(getRolFuncionalities(e.data.Id));
    this.setState({ selectedPerfil: e.data.IdProfile, selectedRowId: e.data.Id, allowEditPerfil: false });

  }
  handleUpdate = (event) => {
    const data = { ...event.oldData, ...event.newData };
    this.props.dispatch(doUpdateRol(data));
  }

  handleEditFunctionalities = () => {
    const isNewRow = this.state.selectedPerfil === "";
    this.props.openModal(isNewRow, this.state.selectedRowId);
  }
  handleFilterChange = (text) => {
    this.tableRef.searchByText(text);
  }


  render() {
    const {
      deleteEvent,
    } = this.state;

    const form = getForm({
      perfiles: this.props.perfiles,
      selectedPerfil: this.state.selectedPerfil,
      modalCallback: this.handleEditFunctionalities,
      eventDataRol: this.props.eventDataRol
    });

    return (
      <React.Fragment >
        <TableFilter
          placeholder="Buscar"
          onChange={this.handleFilterChange}
          show={this.props.roles != null}

          buttons={
            {
              filter: { buttonName: "iconFilter", visible: false, buttonAction: null },
              document: { buttonName: "iconDocument", visible: false, buttonAction: null },
              download: { buttonName: "iconDownload", visible: false, buttonAction: null },
              newItem: {
                buttonName: "custom", visible: true, buttonAction: this.handleAdd, buttonText: "Agregar rol",
              },

            }
          }
        />

        <DataGrid
          dataSource={this.props.roles.map(e => { if (!e.AdminAchsOffices) e.AdminAchsOffices = false; return e; })}
          showBorders={false}
          noDataText="Sin Roles"
          className="custom-table"
          showColumnLines={false}
          ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
          allowColumnResizing={false}
          showRowLines={false}
          rowAlternationEnabled
          onRowRemoving={this.handleRemove}
          onRowInserting={this.handleSave}
          onRowUpdating={this.handleUpdate}
          onEditingStart={this.handleEdit}
          columnAutoWidth={false}
          onInitNewRow={(e) => {
            e.data.AdminAchsOffices = false;
          }}
        >

          <Editing
            mode="popup"
            popup={{
              title: "Roles",
              showTitle: true,
              dragEnabled: false,
              showCloseButton: true,
              width: 700,
              height: 380,
              position: {
                my: "center",
                at: "center",
                of: window,
              },
            }}
            texts={{
              addRow: "Agregar rol",
              saveRowChanges: "Guardar",
              cancelRowChanges: "Cancelar",
              confirmDeleteMessage: "", // '' => no confirmation
              deleteRow: "Borrar",
            }}
            form={form}
          />

          <Column
            dataField="Code"
            allowEditing={false}
            allowAdding={false}
            showEditorAlways={false}
            allowFiltering
            allowSearch={false}
            caption="Código"
            cellComponent={(item) => (
              <div
                title={item.value}
                style={{
                  textAlign: "left", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis",
                }}
              >{item.value}
              </div>)}
          />

          <Column
            dataField="Name"
            validationRules={[
              { type: "required", message: "Debe ingresar un nombre" },
            ]}
            caption="Nombre"
            allowSearch
          />
          <Column
            dataField="IdProfile"
            caption="Perfil"
            editorOptions={{
              disabled: this.state.allowEditPerfil,
            }}
            dataType="LookUp"
            allowSearch
            validationRules={[
              { type: "required", message: "Debe seleccionar un perfil" },
            ]}
            lookup={{
              dataSource: this.props.perfiles,
              displayExpr: "Name",
              valueExpr: "Id",
            }}
            visible={false}
          />

          <Column
            dataField='AdminAchsOffices'
            editorType='dxCheckBox'
            itemType="boolean"
            visible={false}
          />

          <Column
            dataField="IdProfile"
            caption="Perfil"
            editorOptions={{
              disabled: this.state.allowEditPerfil,
            }}
            validationRules={[
              { type: "required", message: "Debe seleccionar un perfil" },
            ]}
            dataType="LookUp"
            allowSearch
            lookup={{
              dataSource: this.props.perfiles,
              displayExpr: "Name",
              valueExpr: "Id",
            }}
          />

          <Column
            dataField="Description"
            caption="Descripción"
            allowSearch
            validationRules={[
              { type: "required", message: "Debe agregar una descripción" },
            ]}
            width="30%"
            headerCellComponent={(item) => <div style={{ textAlign: "left" }}>Descripción</div>}
            cellComponent={(item) => <div title={item.value} style={{ textAlign: "left", whiteSpace: "normal" }}>{item.value}</div>}
          />
          <Column
            alignment="right"
            cellTemplate={(element, props) => {
              ReactDOM.render(
                <div className="button-column">
                  <Button
                    text="Editar"
                    className="slimButton"
                    type="success"
                    style={{ marginRight: 5 }}
                    onClick={() => this.handleOpenModalEdit(props)}
                  />
                  <Button
                    text="Eliminar"
                    className="slimButton"
                    type="danger"
                    onClick={() => this.handleOpenModalDelete(props)}
                  />
                </div>
                , element
              )
            }
            }
          />
          <RemoteOperations
            paging={false}
            filtering
            summary={false}
            groupPaging={false}
            grouping={false}
            sorting={false}
          />
          <Paging
            pageSize={20}
            visible={false}


          />

          <Pager
            visible
            showInfo
            infoText={(page, total, items) => `Página ${page} de ${total} (${items} resultados)`}
          />


        </DataGrid>


        <ModalDelete
          open={this.state.modalDelete}
          title="Eliminar rol"
          step1Main={
            <React.Fragment>
              ¿Seguro quieres eliminar el rol <span style={{ fontWeight: "bold" }}>
                {deleteEvent && deleteEvent.data.Description}
              </span> ?
            </React.Fragment>
          }
          step1Sub="Al eliminar el rol todos los usuarios que tengan este rol asignado perderán sus privilegios."
          step2Main="Esta acción es irreversible"
          step2Sub="¿Seguro quieres eliminar el rol?"
          step2ConfirmationText="Sí, quiero eliminar el rol"
          deleteCallback={this.removeRol}
          cancelCallback={this.handleCancelRemove}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  roles: state.mantenedores.roles,
  perfiles: state.mantenedores.perfiles,
  filtrosTablaRoles: state.mantenedores.filtrosTablaRoles,
  eventDataRol: state.mantenedores.eventDataRol

});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(RolesTable);
